import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SharedModule } from '../../shared/shared.module';
import { HeaderComponent } from './header/header.component';
import { HeaderPhoneComponent } from './header/header-phone.component';
import { InfoBannerComponent } from './header/info-banner/info-banner.component';
import { LoggedUserComponent } from './header/logged-user/logged-user.component';
import { NotificationComponent } from './header/notification/notification.component';
import { WorkplaceSelectorComponent } from './header/workplace-selector/workplace-selector.component';
import { LayoutComponent } from './layout.component';

export const LAYOUT_ROUTES: Routes = [{ path: '', component: LayoutComponent }];

@NgModule({
  declarations: [
    LayoutComponent,
    HeaderComponent,
    NotificationComponent,
    LoggedUserComponent,
    HeaderPhoneComponent,
    WorkplaceSelectorComponent,
    InfoBannerComponent,
  ],
  imports: [CommonModule, SharedModule],
})
export class LayoutModule {}

@NgModule({
  imports: [RouterModule.forChild(LAYOUT_ROUTES), LayoutModule],
  exports: [RouterModule],
})
export class LayoutRoutingModule {}
